<app-topbar></app-topbar>
<div style="overflow-x: hidden;">
    <div class="headerOne">
        <div class="container" style="margin-top: 150px;">
            <div class="row">
                <div class="col-md-6">
                    <p class="headingText">
                        Know Your <br>
                        <span class="blueOrangeGradient"> Order Status </span>
                    </p>
                    <p class="content">Enter AWB tracking number or Order ID &amp; it’s done.</p>
                    <!-- <img src="assets/images/svg/track1.png" class="first"> -->
                </div>
                <div class="col-md-6 secondOne">
                    <div class="card p-4">
                        <div class="d-flex justify-content-between">
                            <p class="track">Track By:</p>
                            <div class="d-flex">
                                <!-- <div class="me-4">
                                    <input type="radio" id="mobile" name="trackOption" [(ngModel)]="selectedOption" value="mobile" class="pt-1 me-2">
                                    <label for="mobile">Mobile Number</label>
                                </div> -->
                                <div class="me-4">
                                    <input type="radio" id="awb" name="trackOption" [(ngModel)]="selectedOption" value="awb" class="pt-1 me-2">
                                    <label for="awb">AWB</label>
                                </div>
                                <div>
                                    <input type="radio" id="order_id" name="trackOption" [(ngModel)]="selectedOption" value="order_id" class="pt-1 me-2">
                                    <label for="order_id">Order Id</label>
                                </div>
                            </div>
                        </div>

                        <!-- Divs to show/hide -->
                        <div *ngIf="selectedOption === 'awb'" id="awbDiv">
                            <input type="text" id="awb" class="form-control mt-4" placeholder="Enter your Airway Bill Number(AWB)">
                            <button class="btn  mt-3" type="submit" id="myBuymore D2C_btn" style="background: #0f9aa4 !important;border: #0f9aa4 !important;border-radius: 4px !important;color: white;">Track Now</button>
                            <p class="can mt-4">Can’t Find Your Order Details?</p>
                            <p class="mt-2">We sent your AWB tracking number to you via Email & SMS upon order confirmation.</p>

                        </div>

                        <div *ngIf="selectedOption === 'order_id'" id="orderIdDiv">
                            <input type="text" id="order_id" class="form-control mt-4" placeholder="Order Id">
                            <!-- <input type="text" id="mobile" class="form-control mt-3" placeholder="Phone Number/Email ID"> -->
                            <button class="btn  mt-3" type="submit" id="myBuymore D2C_btn" style="background: #0f9aa4 !important;border: #0f9aa4 !important;border-radius: 4px !important;color: white;">Track Now</button>
                            <p class="can mt-4">Can’t Find Your Order Details?</p>
                            <p class="mt-2">We sent your AWB tracking number to you via Email & SMS upon order confirmation.</p>
                        </div>

                    </div>
                </div>
            </div>
        </div>

    </div>
    <div style="margin-top: 50px;">
        <div class="upperWrap mb-5 laptop" style="margin-left: 9%!important;">
            <h2 class="headingText">What’s your order <span class="blueOrangeGradient"> status?</span></h2>
        </div>
        <div class="laptop">
            <div class="row align-items-center d-flex justify-content-center">
                <div class="col-md-2 card33 contentWithCards">
                    <div>
                        <img src="assets/images/svg/servies/track/order-recived.png" width="56" height="56">
                        <p>Order Received</p>
                        <p class="content">Your order has been conformed and will be packed</p>
                    </div>
                </div>
                <div class="col-md-2 card33 contentWithCards">
                    <div>
                        <img src="assets/images/svg/servies/track/order-packed.png" width="56" height="56">
                        <p>Order Packed</p>
                        <p class="content">Your order has been packed and handed over to courier partner</p>
                    </div>
                </div>
                <div class="col-md-2 card33 contentWithCards">
                    <div>
                        <img src="assets/images/svg/servies/track/order-in-transit.png" width="56" height="56">
                        <p>Order In-transit</p>
                        <p class="content">Your order is on the right track and will be delivered soon</p>
                    </div>
                </div>
                <div class="col-md-2 card44 contentWithCards">
                    <div>
                        <img src="assets/images/svg/servies/track/out-for-delivery.png" class="card44-img" width="56" height="56">
                        <p>Out For Delivery</p>
                        <p class="content">The courier partner has reached your area and will call you in a while</p>
                    </div>
                </div>
                <div class="col-md-2 contentWithCards">
                    <div>
                        <img src="assets/images/svg/servies/track/delivered.png" class="card33-img" width="56" height="56">
                        <p>Delivered</p>
                        <p class="content">Deliver your customers with</p>
                    </div>
                </div>
            </div>S
        </div>
    </div>
    <div class="container d-flex justify-content-center" style="margin-top: 100px;margin-bottom: 60px;">
        <div class="upperWrap">
            <p class="headingText">Why <span class="blueOrangeGradient"> delivery tracking </span> on-the-go</p>
            <p class="content d-flex justify-content-center">
                Keep track of your shipments with quick courier-tracking using your AWB tracking number
            </p>
        </div>
    </div>
    <div class="one">
        <div class="one">
            <ngb-carousel [interval]="3000" [wrap]="true" [showNavigationArrows]="false" [showNavigationIndicators]="false">
                <ng-template ngbSlide *ngFor="let group of brandImagesGrouped">
                    <div class="row justify-content-center align-items-center my-auto mb-5">
                        <div class="col" *ngFor="let testimonial of group">
                            <div class="d-flex justify-content-center align-items-center">
                                <img [src]="testimonial.image" alt="Logo" title="Logo" style="width: 150px; height: 60px;">
                            </div>
                        </div>
                    </div>
                </ng-template>
            </ngb-carousel>
        </div>
        <!-- <div style="margin-top: 80px;">
        


        <owl-carousel-o [options]="customOptions1">
            <ng-container *ngFor="let testimonial of brandImages; let i = index">
                <ng-template carouselSlide>
                    <div class="row mb-5">
                        <div class="testing d-flex justify-content-center align-items-center">
                            <div class="m-2 text-center">
                                <div class="card-body d-flex flex-column justify-content-center align-items-center">
                                    <div class="image-container">
                                        <div class="d-flex justify-content-center align-items-center">
                                            <img [src]="testimonial.image" alt="Technology" title="Technology">
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </ng-template>
            </ng-container>
        </owl-carousel-o>

    </div> -->
        <div class="container" style="margin-top: 90px; margin-bottom: 100px;">
            <div class="row">
                <div class="col-md-6">
                    <div class="contentWrapper">
                        <h2 class="headingText">Enhance your customer <br> <span class="blueOrangeGradient"> journey with intuitive and seamless order tracking.</span></h2>
                        <p class="content"><strong>Get real-time shipment updates, no matter which courier you use.</strong></p>
                        <button class="linkBtn1 p-2" (click)="onClick5()">Begin Now</button>
                    </div>
                </div>
                <div class="col-md-6 d-flex justify-content-end laptop">
                    <img src="assets/images/svg/servies/trakyourorder1.jpg" width="450px" height="250px" style="border-radius: 15px;">
                </div>
            </div>
        </div>
    </div>

    <app-footer></app-footer>